import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { HeaderBar } from '../../component'
import DOMPurify from 'dompurify'

import './style.css'

export const Summary: React.VFC = () => {
  const { state } = useLocation()
  const { message, icon, gobackUrl } = state

  const navigate = useNavigate()
  return (
    <div>
      <HeaderBar isSummary />
      <div className="container-summary">
        <div className="group-content">
          <img className="img-status" src={icon} alt="icon" />
          <div
            className="text-status-summary"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
          />
        </div>
        <button
          className="done-button"
          onClick={() => (gobackUrl ? navigate(gobackUrl) : navigate('/'))}
        >
          เสร็จสิ้น
        </button>
      </div>
    </div>
  )
}
